"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VanillaMQ = VanillaMQ;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function VanillaMQ() {
  var _this = this;

  var defaults = {
    target: 'document',
    mediaQuery: 'all',
    matches: function matches() {
      console.log("Matched!");
    },
    unmatches: function unmatches() {
      console.log("Didn't match!");
    }
  };
  this.properties = {
    matched: false
  };
  this.options = {}; // Create options by extending defaults with the passed in arugments

  if (arguments[0] && _typeof(arguments[0]) === 'object') {
    this.options = extendDefaults(defaults, arguments[0]);
  } // Private Methods


  function extendDefaults(source, properties) {
    var property;

    for (property in properties) {
      if (properties.hasOwnProperty(property)) {
        source[property] = properties[property];
      }
    }

    return source;
  }

  this.init = function () {
    _this.mq();

    window.matchMedia(_this.options.mediaQuery).addListener(_this.mq);
  };

  this.mq = function () {
    if (window.matchMedia(_this.options.mediaQuery).matches) {
      _this.options.matches();
    } else {
      _this.options.unmatches();
    }
  };

  this.init();
}